import { render, staticRenderFns } from "./UserProductClassify.vue?vue&type=template&id=6d8c9656&"
import script from "./UserProductClassify.vue?vue&type=script&lang=js&"
export * from "./UserProductClassify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports